//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SERVER } from "../api/apiConfig";
import FootButton from "../components/FooterBtn.vue";
import CcDialog from "../components/dialog.vue";
import loading from "../components/loading.vue";
import axios from 'axios';

export default {
  name: "ebookDetail",
  components: {
    FootButton,
    //CcDialog
    loading
  },
  metaInfo() {
    return {
      meta: this.metas
    };
  },
  data() {
    return {
      show: false,
      loading: true,
      columnId: '',
      bookId: "",
      bookData: {},
      pageName: "loading",
      metas: [],
      BuyDialog: false,
      imgNull: require("@/assets/image/icon/icon_null.png"),
      errData:{
        code:false
      },
      isLogin: false,
      userId: '',
      isDiscount: true
    };
  },
  methods: {
    //获取详情页内容
    getData() {
      console.log('thisbookId', this.$route.query);
      let postD = {
        id: this.bookId,
        listId: this.columnId,
        //appid: this.SERVER.APPID ? this.SERVER.APPID : 'h5'
        //isValid: true
      };
      console.log('postD', postD);
      this.$toast.loading();
      this.CCrequest.doSessionAxios(this.CONFIG.MEDIA.GET, postD, "GET", "no login")
        .then(res => {
          this.bookData = res;

          this.$toast.close();
          this.show = true;
          console.log('res', res);
        })
        .catch(err => {
          console.log("request err1111", err);
            this.$toast.close();
            if(err.response.data &&err.response.data.message){
                this.errData = err.response.data
            }
        });
    },
    //跳轉購買頁
    goBuy() {

      if(this.SERVER.APPID == "orangenews"){
        if(this.isLogin){
          this.$routerHelper.goBuyPage(this.$router,this.columnId,"media")
        }else{
          this.$router.push({
            path: '/login'
          })
        }
      }else{
        if(this.isLogin){
          this.$routerHelper.goBuyPage(this.$router,this.columnId,"media")
        }else{
          this.$dialog.confirm({
            message: this.$t('AUDIOPLAYERDE_LANG.shwoDialogLogin.1'),
            confirmButtonText: this.$t('AUDIOPLAYERDE_LANG.shwoDialogLogin.2')
          }).then(() => {
            this.$router.push({
              path: '/login'
            })
          }).catch(() => { });
        }
      }
        // this.$router.push({
        //   path: '/buy',
        //   query:{
        //     id: this.columnId,
        //     objType: 'media',
        //     appid: this.SERVER.APPID,
        //     thirdPartToken: this.LOGIN2.getThirdPartToken()
        //   }
        // })
    },
    //跳轉阅读
    goRead(id){
      // this.$router.push({
      //   path: '/reader',
      //   query:{
      //     src: id
      //   }
      // })
      this.$routerHelper.openReader(id)
    },
    //返回上一页
    onClickLeft(){
      this.$router.back()
    }
  },
  mounted() {
    this.bookId = this.$route.query.id
    this.columnId = this.$route.query.id
    this.getData();

    //判斷是否登錄
    this.LOGIN2.getSession("no login")
      .then(session => {
        this.isLogin = true;
      })
      .catch(err => {
        this.isLogin = false;
      });
  },
  beforeRouteEnter(to, from, next) {
    //console.log('to', to.path, to);
    next(vm => {
      if(from.path == '/list') {
        vm.isDiscount = false
      } else {
        vm.isDiscount = true
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/pages/ebookDetail.vue